import { render, staticRenderFns } from "./EditPaymentOnDeliveryConfig.vue?vue&type=template&id=7b4b7778&"
import script from "./EditPaymentOnDeliveryConfig.vue?vue&type=script&lang=ts&"
export * from "./EditPaymentOnDeliveryConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports